import type { FaireCollectionEntity } from "../../entity_types/collection";

export const col_heritage_holiday: FaireCollectionEntity = {
  token: "col_heritage-holiday",
  type: "collection",
  name: "A Heritage Holiday",
  description: "Classic Christmas charm with timeless appeal.",
  thumbnailUrl:
    "https://images.unsplash.com/photo-1543589077-47d81606c1bf?w=400&h=400&fit=crop",
  season: "winter",
  itemCount: 42,
  brandToken: "catalog_brand_audreys_home_gift",
  productTokens: [],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
